import * as React from 'react'
import { Fund } from '../../../types'
import { CardTitle } from '../../atoms/CardTitle'
import { FundsTable } from '../../common/FundsTable'
import { HelpProps } from '@/components/common/Help'

type Props = {
  list: Fund[]
  investorShortname: string
  className?: string
  helpText?: string
  helpProps?: HelpProps
}

export const InvestorFunds: React.FC<Props> = (props) => {
  return (
    <>
      <CardTitle helpText={props.helpText} helpProps={props.helpProps}>
        ファンド
      </CardTitle>
      <FundsTable
        list={props.list}
        investorShortName={props.investorShortname}
      />
    </>
  )
}
